import { VehicleStatuses } from 'common/constants'
import {
  StyledAuctionPrice,
  StyledAuctionText,
  StyledAvailableVehicleNumber,
  StyledNoAvailable,
  StyledSearchButton,
  StyledTag
} from 'modules/BuyerActivity/VehicleAuction.styled'
import { useContext, useState, useEffect } from 'react'
import { VehicleContext } from './VehicleContext'
import { normalizeCurrencySymbol } from 'utils/currencyUtils'
import { StyledAuctionTimeRemaining } from 'modules/BuyerActivity/CountDown.styled'

import { quickSearch } from 'apis/vehicleApis'
import { ISearchVehiclesRequest } from 'types/vehicleTypes'
import { Loader } from 'components/Loader'

export const VehiclePriceSection = () => {
  const {
    vehicleData: { vehicle: vehicleInfo, auctionInfo, IsAvailable }
  } = useContext(VehicleContext)
  const [availableVehicleNumber, setAvailableVehicleNumber] = useState<number>(0)
  const [isLoading, setIsLoading] = useState(false)

  const renderGroundingInfo = () => {
    const hasGroundingDate = vehicleInfo?.GroundingCompletionDate?.length > 0
    const showGroundingText =
      (vehicleInfo.StatusID === VehicleStatuses.AwaitingConsignment ||
        vehicleInfo.StatusID === VehicleStatuses.AuctionRollOff) &&
      hasGroundingDate
    const showTimeLeft = vehicleInfo.StatusID === VehicleStatuses.AuctionRollOff && hasGroundingDate
    return (
      <>
        {showGroundingText && (
          <StyledAuctionText>
            <span>Grounding on:</span> {vehicleInfo.GroundingCompletionDate}
          </StyledAuctionText>
        )}
        {showTimeLeft && (
          <StyledAuctionTimeRemaining>
            <strong>{vehicleInfo.TimeLeft} in current status</strong>
          </StyledAuctionTimeRemaining>
        )}
      </>
    )
  }
  const getAvailableVehicleNumber = async () => {
    setIsLoading(true)
    try {
      const request: ISearchVehiclesRequest = {
        Ids: [],
        FilterOptions: {
          IsReserveMetVehicles: false,
          IsRecentlyAddedVehicles: false
        },
        QuickSearch: false,
        ReturnVehicles: false,
        ReturnZeroCountFilters: false,
        PageNumber: 0,
        PageSize: 10,
        SearchQuery: {
          ReturnOnlyVehicles: false,
          SearchFilters: [],
          SortBy: [],
          StatusIds: []
        }
      }
      const result = await quickSearch(request)
      setAvailableVehicleNumber(result.TotalRecords)
    } catch (error) {
      console.error('Failed to get available vehicle count:', error)
      setAvailableVehicleNumber(0)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!IsAvailable) {
      getAvailableVehicleNumber()
    }
  }, [IsAvailable])

  const handleSearchClick = () => {
    window.location.href = '/search?clearSearch=true'
  }

  return (
    <>
      {IsAvailable ? (
        <>
          {vehicleInfo.StatusID === VehicleStatuses.SoldNotFunded && (
            <>
              <StyledAuctionPrice>
                {vehicleInfo.BuyItNowPrice !== 0 && normalizeCurrencySymbol(vehicleInfo.BuyItNowPriceString)}
              </StyledAuctionPrice>
            </>
          )}

          {vehicleInfo.StatusID !== VehicleStatuses.SoldNotFunded && vehicleInfo.StatusID !== VehicleStatuses.OnSale && (
            <div>
              <StyledTag className="fit-content">
                <span>{vehicleInfo.StatusDescription}</span>
              </StyledTag>
              {renderGroundingInfo()}
            </div>
          )}

          {vehicleInfo.StatusID === VehicleStatuses.OnSale && (
            <div>
              {auctionInfo && (
                <>
                  <StyledAuctionPrice>{normalizeCurrencySymbol(auctionInfo.CurrentPriceString)}</StyledAuctionPrice>
                </>
              )}
              {!auctionInfo && (
                <StyledAuctionPrice>{normalizeCurrencySymbol(vehicleInfo.FinalPriceString)}</StyledAuctionPrice>
              )}
            </div>
          )}
        </>
      ) : (
        <>
          <StyledNoAvailable>
            <span>NO LONGER AVAILABLE</span>
          </StyledNoAvailable>
          {isLoading && <Loader />}
          {availableVehicleNumber > 0 && !isLoading && (
            <>
              <StyledAvailableVehicleNumber>
                This vehicle is no longer available. We have{' '}
                <strong>{availableVehicleNumber} available vehicles,</strong> would you like to search those?
              </StyledAvailableVehicleNumber>
              <StyledSearchButton variant="primary" onClick={handleSearchClick}>
                Search Vehicles
              </StyledSearchButton>
            </>
          )}
        </>
      )}
    </>
  )
}
